export const ACCION_TIPOS = [
  { value: "intercambio_estudiantil", label: "Intercambio estudiantil", dir: true },
  { value: "pasantia_docente", label: "Pasantía docente", dir: true },
  { value: "proyecto_investigacion", label: "Proyecto de investigación conjunto", dir: false },
  { value: "publicacion_conjunta", label: "Publicación conjunta", dir: false },
  { value: "cotutela_tesis", label: "Cotutela de tesis", dir: true },
  { value: "evento_seminario", label: "Evento o seminario conjunto", dir: false },
  { value: "visita_institucional", label: "Visita institucional", dir: true },
  { value: "otro", label: "Otro", dir: false },
];

export const ACCION_TIPO_LABEL = ACCION_TIPOS.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

export const ESTADO_LABEL = {
  activo: "Activo",
  por_vencer: "Por vencer",
  vencido: "Vencido",
};

export const ESTADO_COLOR = {
  activo: { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-300", hex: "#047857" },
  por_vencer: { text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-300", hex: "#d97706" },
  vencido: { text: "text-red-700", bg: "bg-red-50", border: "border-red-300", hex: "#b91c1c" },
};

export const DIRECCION_LABEL = {
  entrante: "Entrante",
  saliente: "Saliente",
  n_a: "N/A",
};

export const ROLE_LABEL = {
  admin: "Oficina de Vinculación",
  facultad: "Facultad",
  unidad: "Unidad Académica",
  directivo: "Directivo",
};

export const VIGENCIA_LABEL = {
  fijo: "Con vencimiento fijo",
  indefinido: "Indefinido",
  auto_renovable: "Renovación automática",
};

export const VIGENCIA_SHORT = {
  fijo: "Fijo",
  indefinido: "Indefinido",
  auto_renovable: "Auto-renovable",
};
